//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PaO2FiO2ratio',
  data () {
    return {
      defaultJson: {
        'PaO₂ / FiO₂ ratio': 'PaO₂ / FiO₂ 比',
        'Compatible with mild ARDS': '符合轻度 ARDS',
        'FiO₂': 'FiO₂',
        'PaO₂': 'PaO₂',
        'Compatible with moderate ARDS': '符合中度 ARDS',
        'Compatible with severe ARDS': '符合重度 ARDS'
      },
      form: {
        fio2: '',
        po2: ''
      },
      contentDescription: '',
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // po2/fio2
        console.log(form)
        let result = (form.po2 / (form.fio2 * 0.01)).toFixed(1)
        console.log(result)
        if (result < 100) {
          self.descTxt = '符合重度 ARDS'
        } else if (result < 200) {
          self.descTxt = '符合中度 ARDS'
        } else if (result < 300) {
          self.descTxt = '符合轻度 ARDS'
        } else {
          self.descTxt = ''
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/PaO2FiO2ratio.vue